<template>
  <DialogHeader>
    <template #right>
      <div class="text-green-900 cursor-pointer" @click="close()">Close</div>
    </template>
    Add a profile photo
  </DialogHeader>
  <DialogContent>
    <div
      class="w-full h-[130px] flex justify-center items-center font-primary text-[16px] leading-[18px] text-gray-800 rounded-md border"
      :class="classes"
      @dragover.prevent="handleDragOver"
      @dragleave.prevent="handleDragLeave"
      @drop.prevent="handleDrop"
    >
      <div v-if="!dragging" class="text-center" :class="textClasses">
        <span class="font-secondary">Drag and drop or</span>
        <span
          class="font-secondary font-medium text-green-900 cursor-pointer"
          @click="handleUploadClick"
        >
          upload from computer
        </span>
      </div>
      <div v-else class="font-secondary pointer-events-none">
        Drop file to upload
      </div>
    </div>
  </DialogContent>
</template>

<script setup lang="ts">
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import { Dialogs } from '@/shared/dialogs/types'
import { useDialog } from '@/shared/dialogs/useDialog'
import { computed, ref } from 'vue'

const { open, close } = useDialog()

const dragging = ref(false)

const classes = computed(() => ({
  'border-green-900 bg-green-900/5': dragging.value,
  'border-gray-800/20': !dragging.value,
}))

const textClasses = computed(() => ({
  'pointer-events-none': dragging.value,
}))

const handleDragOver = () => {
  dragging.value = true
}

const handleDragLeave = () => {
  dragging.value = false
}

const handleFile = (file: File) => {
  open(Dialogs.ConfirmProfilePicture, {
    props: { file },
  })
}

const handleDrop = async (event: DragEvent) => {
  dragging.value = false

  const file = event.dataTransfer?.files[0]

  if (file && file.type.startsWith('image')) {
    handleFile(file)
  }
}

const handleUploadClick = () => {
  const input = document.createElement('input')
  input.type = 'file'
  input.accept = 'image/*'
  input.click()

  input.onchange = async (event: Event) => {
    const file = (event.target as HTMLInputElement).files?.[0]

    if (!file) return

    handleFile(file)
  }
}
</script>
